import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import "../components/ContentContainerStyles.css";

// function resizeFrame() {
//     window.addEventListener('message', function (e) {
//         console.log()
//         const {type, data} = JSON.parse(e.data);
//         if (type === 'igem-attribution-form') {
//           const element = document.getElementById('igem-attribution-form')
//           element.style.height = data + 50 +'px'
//         }
//     });
// }

function Attributions(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig15.jpg"
                title="Attributions"
            />

            <div className="content-container">
                <iframe
                    style={{
                        minHeight:"98vh",
                        margin: "5rem",
                    }}
                    title="Team attribution form"

                    width="80%"
                    class="igem-attribution-form"
                    src="https://attributions.igem.org?team=HKU-HongKong&year=2023"
                >
                </iframe>
 

            </div>
            


            <Footer/>
        </>
    )
}

export default Attributions;